'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './stationaccess.routes';

export class StationaccessComponent {
  /*@ngInject*/
  constructor($state, $scope, navService, lookup, fetch, userService, $stateParams) {
    const vm = this;
    this.$scope = $scope;
    this.$state = $state;
    this.navService = navService;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$stateParams = $stateParams;
    this.userService = userService;
    this.$scope.activityType = 'Station Area Access';

    /**
* Update station area dropdown based on jurisdiction selected
* @param {*} jurisdiction 
*/
$scope.getStationAreaList = function (jurisdiction) {
  lookup.setJurisdiction(jurisdiction);
  fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
    .then(response => {
      
      $scope.stationAreas = response.data;
      if (lookup.getCurrentStation()) {
        $scope.currentSelectedStationId = lookup.getCurrentStation();
        $scope.getStationbyID($scope.currentSelectedStationId)
      }
    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        $state.go('login');
      }
    })
}
    /**
     * Retrieves a list of jurisdictions from the backend API and populates the `jurisdictions` array in the scope.
     * 
     * @memberof StationaccessComponent
     */
    // $scope.getJurisdictionList = function () {
    //   fetch.getAllItems('api/data/jurisdictions/list')
    //     .then(response => {

    //       $scope.jurisdictions = response.data;
    //       $scope.jurisdiction = response.data[0].jurisdiction;
    //       // $scope.getStationAreaList($scope.jurisdiction);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       if (err.status === 403) {
    //         $state.go('login');
    //       }
    //     })
    // }

    $scope.getStationbyID = function (station) {
      $scope.loadingSummaries = true;
      if (station) {
        $scope.currentSelectedStationId = station;
        lookup.setCurrentStation(station);
      }

         vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
        

      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Station Area Access')
        .then(response => {

          $scope.stationCompleteStreets = _.filter(response.data, { 'submission_policy_name': 'Complete Streets Policy' });
          $scope.stationGapAnalysis = _.filter(response.data, { 'submission_policy_name': 'Gap Analysis' });
          $scope.stationProjectPrioritization = _.filter(response.data, { 'submission_policy_name': 'Project Prioritization' });
          $scope.stationMobilityHubPlanning = _.filter(response.data, { 'submission_policy_name': 'Mobility Hub Planning' });
          $scope.loadingSummaries = false;
          $scope.getActivity();
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.getActivity = function () {
      var activityData = [];
      fetch.getAllItems(`api/data/submission/activity/${$scope.currentSelectedStationId}/${$scope.activityType}`)
        .then(response => {

          $scope.submissionActivity = response.data;
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }
  }

  $onInit() {
    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        this.userService.setCurrentUser(response.data);
        this.getJurisdictionList();

      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })

  }

  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
    .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

    // Check if user role is Administrator
    if (this.$scope.currentUser.role === 'Administrator') {
      console.log("admin");
      // Check for the jurisdiction parameter in the URL
      const jurisdictionParam = this.$stateParams.jurisdiction;
      console.log(this.$stateParams);
      if (jurisdictionParam) {
        this.$scope.currentJurisdiction = jurisdictionParam;
      } else if (this.lookup.getJurisdiction()) {
        this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
      } else {
        // If no parameter, default to the first jurisdiction
        this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
      }
    } else {
       if (this.lookup.getJurisdiction()) {
        this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
      } else {
        // If no parameter, default to the first jurisdiction
        this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
      }
    }

        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
    })
    .catch(err => {
        console.log(err);
    });
}

getStationAreaSubmissionSummary(stationId) {
  console.log('Getting summary for station:', stationId);
  this.lookup.setCurrentStation(stationId);

  if (this.$scope.stationAreas.length > 0) {
    this.$scope.stationAreas.forEach(element => {
      element.active = element.sta_recid === stationId;
      if (element.active) {
        this.$scope.stationAreaTitle = element.station_name;
      }
    });

    return this.fetch.getItem(
      `api/data/policies/${this.$scope.currentJurisdiction}`,
      stationId
    )
      .then(response => {
        console.log('Policy data:', response);
        this.$scope.submissionSummary = response.data;
        console.log("submission summary: ", this.$scope.submissionSummary);

        // Process density submissions
        this.$scope.densitySubmissions = _.filter(response.data,
          { submission_policy_type: "Density" });
        this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
          { submitted: true });
        this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
          { status: 'Compliant' });

        // Process housing policy submissions
        this.$scope.housingPolicySubmissions = _.filter(response.data,
          { submission_policy_type: "Housing Production Policy" });
        this.$scope.housingPolicySubmissions = _.union(
          this.$scope.housingPolicySubmissions,
          _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
          _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
          _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
        );
        this.$scope.housingPolicySubmitted = _.filter(
          this.$scope.housingPolicySubmissions,
          { submitted: true }
        );
        this.$scope.housingPolicyCompliant = _.filter(
          this.$scope.housingPolicySubmissions,
          { status: 'Compliant' }
        );

        // Process parking submissions
        this.$scope.parkingSubmissions = _.filter(response.data,
          { submission_policy_type: "Parking" });
        this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
          { submitted: true });
        this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
          { status: 'Compliant' });

        // Process station access submissions
        this.$scope.stationAccessSubmissions = _.filter(response.data,
          { submission_policy_type: "Station Area Access" });
        this.$scope.stationAccessSubmitted = _.filter(
          this.$scope.stationAccessSubmissions,
          { submitted: true }
        );
        this.$scope.stationAccessCompliant = _.filter(
          this.$scope.stationAccessSubmissions,
          { status: 'Compliant' }
        );
      });

    this.$scope.loading = false;
  } else {
    this.$scope.stationAreaTitle = '--';
    return Promise.resolve();
  }
}




}

export default angular.module('websiteApp.stationaccess', [uiRouter])
  .config(routes)
  .component('stationaccess', {
    template: require('./stationaccess.html'),
    controller: StationaccessComponent,
    controllerAs: 'stationaccessCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/stationaccess.component.js